import { render, staticRenderFns } from "./DealWorkflowFiles.vue?vue&type=template&id=a65830b0&scoped=true"
import script from "./DealWorkflowFiles.vue?vue&type=script&lang=js"
export * from "./DealWorkflowFiles.vue?vue&type=script&lang=js"
import style0 from "./DealWorkflowFiles.vue?vue&type=style&index=0&id=a65830b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a65830b0",
  null
  
)

export default component.exports